export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  image: string;
  description: string;
  rating: number;
  year: number;
  region: string;
  actors: string[];
  director: string;
  episodes: string;
  tags: string[];
  featured: boolean;
  isNew: boolean;
  isHot: boolean;
  views: string;
  updateInfo: string;
}

export const categories = [
  { name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line' },
  { name: '电影', slug: 'dianying', icon: 'ri-film-line' },
  { name: '综艺', slug: 'zongyi', icon: 'ri-live-line' },
  { name: '动漫', slug: 'dongman', icon: 'ri-ghost-line' },
  { name: '纪录片', slug: 'jilupian', icon: 'ri-camera-line' },
  { name: '短剧', slug: 'duanju', icon: 'ri-smartphone-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '长安十二时辰',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20drama%20poster%20with%20warriors%20in%20traditional%20armor%20against%20a%20dramatic%20night%20cityscape%20of%20Changan%2C%20cinematic%20lighting%2C%20epic%20composition%2C%20movie%20poster%20style%2C%20dark%20moody%20tones%20with%20gold%20accents%2C%20professional%20photography&width=600&height=800&seq=video-changan&orientation=portrait',
    description: '唐朝天宝三年，上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。一场关乎大唐命运的生死较量由此展开。',
    rating: 8.3,
    year: 2019,
    region: '中国大陆',
    actors: ['雷佳音', '易烊千玺', '周一围', '芦芳生'],
    director: '曹盾',
    episodes: '48集全',
    tags: ['古装', '悬疑', '历史', '动作'],
    featured: true,
    isNew: false,
    isHot: true,
    views: '125.6万',
    updateInfo: '已完结',
  },
  {
    id: 'v002',
    title: '流浪地球2',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronauts%20and%20massive%20space%20station%20against%20a%20cosmic%20backdrop%2C%20epic%20cinematic%20lighting%2C%20futuristic%20technology%2C%20dramatic%20composition%2C%20movie%20poster%20design%2C%20deep%20space%20atmosphere%2C%20professional%20photography&width=600&height=800&seq=video-wandering-earth&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，年轻人再次挺身而出，展开争分夺秒的生死之战。',
    rating: 8.6,
    year: 2023,
    region: '中国大陆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    director: '郭帆',
    episodes: '1部',
    tags: ['科幻', '灾难', '冒险', '动作'],
    featured: true,
    isNew: false,
    isHot: true,
    views: '358.2万',
    updateInfo: '已上映',
  },
  {
    id: 'v003',
    title: '庆余年 第二季',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20a%20young%20scholar%20in%20traditional%20robes%20holding%20a%20book%2C%20ancient%20Chinese%20palace%20in%20background%2C%20warm%20golden%20lighting%2C%20elegant%20composition%2C%20movie%20poster%20style%2C%20mysterious%20atmosphere%2C%20professional%20photography&width=600&height=800&seq=video-qingyunian&orientation=portrait',
    description: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣，二人的矛盾就此激发。范闲所面对的抱月楼迷局，以及接踵而至的春闱危机，都是二皇子精心给范闲布下的陷阱。',
    rating: 8.8,
    year: 2024,
    region: '中国大陆',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    episodes: '更新至36集',
    tags: ['古装', '权谋', '奇幻', '剧情'],
    featured: true,
    isNew: true,
    isHot: true,
    views: '689.4万',
    updateInfo: '每周一至周五更新2集',
  },
  {
    id: 'v004',
    title: '王牌对王牌 第八季',
    category: '综艺',
    categorySlug: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20colorful%20stage%20lights%20and%20celebrity%20hosts%20in%20stylish%20outfits%2C%20entertainment%20show%20atmosphere%2C%20bright%20vibrant%20colors%2C%20playful%20composition%2C%20TV%20show%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-wangpai&orientation=portrait',
    description: '沈腾、贾玲、华晨宇、关晓彤等王牌家族成员齐聚，与飞行嘉宾展开趣味游戏对决，爆笑不断，欢乐升级。',
    rating: 7.9,
    year: 2024,
    region: '中国大陆',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    director: '浙江卫视',
    episodes: '更新至第10期',
    tags: ['真人秀', '搞笑', '游戏', '明星'],
    featured: false,
    isNew: true,
    isHot: true,
    views: '456.8万',
    updateInfo: '每周五更新',
  },
  {
    id: 'v005',
    title: '深海',
    category: '动漫',
    categorySlug: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20a%20young%20girl%20diving%20into%20a%20magical%20underwater%20world%20filled%20with%20colorful%20sea%20creatures%2C%20dreamy%20particle%20effects%2C%20stunning%20visuals%2C%20cinematic%20lighting%2C%20anime%20movie%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-shenhai&orientation=portrait',
    description: '在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。',
    rating: 8.4,
    year: 2023,
    region: '中国大陆',
    actors: ['苏鑫', '王亭文'],
    director: '田晓鹏',
    episodes: '1部',
    tags: ['奇幻', '冒险', '治愈', '3D'],
    featured: false,
    isNew: false,
    isHot: true,
    views: '201.3万',
    updateInfo: '已上映',
  },
  {
    id: 'v006',
    title: '繁花',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20poster%20with%20elegant%20characters%20in%20vintage%20fashion%20against%20neon-lit%20cityscape%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20composition%2C%20movie%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-fanhua&orientation=portrait',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人都有故事，处处皆是传奇。',
    rating: 9.0,
    year: 2024,
    region: '中国大陆',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    episodes: '30集全',
    tags: ['都市', '商战', '年代', '剧情'],
    featured: true,
    isNew: true,
    isHot: true,
    views: '892.1万',
    updateInfo: '已完结',
  },
  {
    id: 'v007',
    title: '封神第一部',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20warriors%20in%20elaborate%20armor%20fighting%20mythical%20beasts%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20cinematic%20composition%2C%20movie%20poster%20design%2C%20professional%20photography&width=600&height=800&seq=video-fengshen&orientation=portrait',
    description: '殷商末年，纣王暴虐无道。昆仑仙人姜子牙携封神榜下山，寻找天下共主，以救苍生。一场横跨人、仙、妖三界的大战即将展开。',
    rating: 8.2,
    year: 2023,
    region: '中国大陆',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    director: '乌尔善',
    episodes: '1部',
    tags: ['奇幻', '神话', '战争', '史诗'],
    featured: true,
    isNew: false,
    isHot: true,
    views: '523.7万',
    updateInfo: '已上映',
  },
  {
    id: 'v008',
    title: '披荆斩棘 第四季',
    category: '综艺',
    categorySlug: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20male%20celebrities%20on%20stage%20performing%2C%20dramatic%20stage%20lighting%2C%20concert%20atmosphere%2C%20dynamic%20composition%2C%20TV%20show%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-pijingzhanji&orientation=portrait',
    description: '来自不同领域的哥哥们齐聚舞台，通过多轮竞演挑战自我、突破极限，展现滚烫的人生力量。',
    rating: 7.8,
    year: 2024,
    region: '中国大陆',
    actors: ['李克勤', '林依轮', '王铮亮', '胡夏'],
    director: '芒果TV',
    episodes: '更新至第8期',
    tags: ['音乐', '竞演', '真人秀', '励志'],
    featured: false,
    isNew: true,
    isHot: false,
    views: '312.5万',
    updateInfo: '每周四更新',
  },
  {
    id: 'v009',
    title: '斗破苍穹 年番',
    category: '动漫',
    categorySlug: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20a%20young%20warrior%20wielding%20a%20massive%20sword%20surrounded%20by%20flames%2C%20martial%20arts%20fantasy%20world%2C%20epic%20battle%20scene%2C%20anime%20art%20style%2C%20dramatic%20lighting%2C%20professional%20illustration&width=600&height=800&seq=video-doupo&orientation=portrait',
    description: '萧炎，昔日天才沦落为废柴，受尽冷眼与嘲讽。偶然间，一枚戒指改变了他的命运，从此踏上成为强者的逆袭之路。',
    rating: 8.1,
    year: 2024,
    region: '中国大陆',
    actors: ['张沛', '宝木中阳', '陈张太康'],
    director: '阅文动漫',
    episodes: '更新至第89集',
    tags: ['玄幻', '热血', '战斗', '3D'],
    featured: false,
    isNew: false,
    isHot: true,
    views: '567.3万',
    updateInfo: '每周日更新',
  },
  {
    id: 'v010',
    title: '好事成双',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20poster%20with%20two%20stylish%20women%20in%20a%20luxury%20apartment%2C%20contemporary%20city%20life%2C%20warm%20lighting%2C%20elegant%20composition%2C%20TV%20drama%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-haoshi&orientation=portrait',
    description: '曾是一流大学高材生的林双，婚后迅速怀孕成了全职妈妈，但为家庭全身心付出的她遭遇背叛。离婚在即，为了争夺女儿的抚养权，林双不得不重返职场。',
    rating: 7.6,
    year: 2023,
    region: '中国大陆',
    actors: ['张小斐', '黄晓明', '张嘉倪', '李泽锋'],
    director: '滕华涛',
    episodes: '36集全',
    tags: ['都市', '职场', '情感', '女性'],
    featured: false,
    isNew: false,
    isHot: false,
    views: '189.6万',
    updateInfo: '已完结',
  },
  {
    id: 'v011',
    title: '飞驰人生2',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20cars%20on%20a%20desert%20track%20kicking%20up%20dust%2C%20dynamic%20action%20shot%2C%20cinematic%20lighting%2C%20exciting%20composition%2C%20movie%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-feichi2&orientation=portrait',
    description: '昔日冠军车手张驰沦为落魄驾校教练，过着靠脸吃饭的生活。不料天上掉馅饼，濒临停产的老头乐车厂厂长主动提出赞助张驰组建车队。',
    rating: 7.9,
    year: 2024,
    region: '中国大陆',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜'],
    director: '韩寒',
    episodes: '1部',
    tags: ['喜剧', '运动', '赛车', '励志'],
    featured: false,
    isNew: true,
    isHot: true,
    views: '478.9万',
    updateInfo: '已上映',
  },
  {
    id: 'v012',
    title: '相声有新人',
    category: '综艺',
    categorySlug: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20comedy%20crosstalk%20show%20poster%20with%20performers%20in%20traditional%20robes%20on%20stage%2C%20warm%20stage%20lighting%2C%20classical%20Chinese%20theater%20atmosphere%2C%20entertainment%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-xiangsheng&orientation=portrait',
    description: '全国优秀青年相声演员同台竞技，传承中华传统曲艺文化，展现新时代相声的独特魅力。',
    rating: 8.0,
    year: 2023,
    region: '中国大陆',
    actors: ['郭德纲', '张国立', '孟鹤堂', '周九良'],
    director: '东方卫视',
    episodes: '12期全',
    tags: ['曲艺', '喜剧', '传统文化', '竞演'],
    featured: false,
    isNew: false,
    isHot: false,
    views: '156.2万',
    updateInfo: '已完结',
  },
  {
    id: 'v013',
    title: '凡人修仙传 年番',
    category: '动漫',
    categorySlug: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%20with%20a%20lone%20swordsman%20standing%20on%20a%20mountain%20peak%20surrounded%20by%20floating%20islands%2C%20mystical%20atmosphere%2C%20xianxia%20fantasy%20world%2C%20anime%20art%20style%2C%20dramatic%20lighting%2C%20professional%20illustration&width=600&height=800&seq=video-fanren&orientation=portrait',
    description: '一个普通的山村穷小子，偶然之下跨入一个江湖小门派，虽然资质平庸，但依靠自身努力和合理算计修炼成仙。',
    rating: 8.5,
    year: 2024,
    region: '中国大陆',
    actors: ['钱文青', '杨天翔', '乔诗语'],
    director: '万维猫动漫',
    episodes: '更新至第76集',
    tags: ['修仙', '热血', '冒险', '3D'],
    featured: false,
    isNew: false,
    isHot: true,
    views: '489.1万',
    updateInfo: '每周六更新',
  },
  {
    id: 'v014',
    title: '河边的错误',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20art%20house%20crime%20thriller%20movie%20poster%20with%20a%20detective%20in%20a%20misty%20riverside%20town%2C%20noir%20atmosphere%2C%20moody%20lighting%2C%20mysterious%20composition%2C%20film%20festival%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-hebian&orientation=portrait',
    description: '一桩吊诡的凶案牵扯出多名嫌疑人，刑警队长马哲被无法言喻的真相不断拨弄，逐渐陷入荒诞、不安和分不清是真是幻的时刻与记忆中。',
    rating: 7.8,
    year: 2023,
    region: '中国大陆',
    actors: ['朱一龙', '曾美慧孜', '侯天来'],
    director: '魏书钧',
    episodes: '1部',
    tags: ['犯罪', '悬疑', '文艺', '剧情'],
    featured: false,
    isNew: false,
    isHot: false,
    views: '98.7万',
    updateInfo: '已上映',
  },
  {
    id: 'v015',
    title: '消失的她',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20movie%20poster%20with%20a%20woman%20in%20a%20red%20dress%20in%20a%20tropical%20resort%20setting%2C%20mysterious%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20movie%20poster%20style%2C%20professional%20photography&width=600&height=800&seq=video-xiaoshi&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，在他苦寻无果之时妻子再次现身，何非却坚持眼前的陌生女人并非妻子，夫妻二人似乎都有着不可告人的秘密。',
    rating: 7.5,
    year: 2023,
    region: '中国大陆',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    director: '崔睿',
    episodes: '1部',
    tags: ['悬疑', '犯罪', '剧情', '反转'],
    featured: false,
    isNew: false,
    isHot: true,
    views: '612.4万',
    updateInfo: '已上映',
  },
  {
    id: 'v016',
    title: '大秦帝国之纵横',
    category: '纪录片',
    categorySlug: 'jilupian',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20documentary%20poster%20with%20ancient%20Qin%20Dynasty%20terracotta%20warriors%20and%20imperial%20palace%2C%20golden%20epic%20lighting%2C%20grand%20historical%20scale%2C%20cinematic%20documentary%20style%2C%20professional%20photography&width=600&height=800&seq=video-daqin&orientation=portrait',
    description: '以秦国为主线，讲述从秦孝公到秦始皇一百六十余年波澜壮阔的帝国崛起史，深入还原大秦帝国纵横天下的历史真相。',
    rating: 9.2,
    year: 2022,
    region: '中国大陆',
    actors: ['王志飞', '侯勇', '高圆圆'],
    director: '央视纪录频道',
    episodes: '10集全',
    tags: ['历史', '纪录片', '大秦', '文化'],
    featured: false,
    isNew: false,
    isHot: false,
    views: '87.3万',
    updateInfo: '已完结',
  },
];

export const getVideosByCategory = (slug: string): VideoItem[] => {
  return videos.filter((v) => v.categorySlug === slug);
};

export const getVideoById = (id: string): VideoItem | undefined => {
  return videos.find((v) => v.id === id);
};

export const getFeaturedVideos = (): VideoItem[] => {
  return videos.filter((v) => v.featured);
};

export const getNewVideos = (): VideoItem[] => {
  return videos.filter((v) => v.isNew);
};

export const getHotVideos = (): VideoItem[] => {
  return videos.filter((v) => v.isHot);
};

export const getCategoryName = (slug: string): string => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};